import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["view", "edit"]

  connect() {
    // Ensure we start with view mode
    this.showView()
  }

  edit() {
    this.viewTarget.classList.add("hidden")
    this.editTarget.classList.remove("hidden")

    // Focus the textarea
    const textarea = this.editTarget.querySelector("textarea")
    if (textarea) {
      textarea.focus()
      textarea.setSelectionRange(textarea.value.length, textarea.value.length)
    }
  }

  cancel(event) {
    event.preventDefault()
    this.showView()
  }

  showView() {
    this.viewTarget.classList.remove("hidden")
    this.editTarget.classList.add("hidden")
  }
}